import { logger } from "./utils/logger.es.js";
import { p as parseCookies } from "./cookies-04bd2321.js";
import { w as waitFor } from "./waitFor-1b67bbb8.js";
const UTAG_COOKIE_KEY_LEGACY = "utag_main";
const UTAG_COOKIE_SESSION_ID_KEY_LEGACY = "ses_id";
const UTAG_COOKIE_VISITOR_ID_KEY_LEGACY = "v_id";
const UTAG_COOKIE_SESSION_ID_KEY = "utag_main_ses_id";
const UTAG_COOKIE_VISITOR_ID_KEY = "utag_main_v_id";
const utag = () => window.utag;
const getNonLegacySessionId = (cookies) => {
  const sessionCookie = cookies[UTAG_COOKIE_SESSION_ID_KEY];
  return sessionCookie == null ? void 0 : sessionCookie.replace(";exp-session", "");
};
const getNonLegacyVisitorId = (cookies) => {
  return cookies[UTAG_COOKIE_VISITOR_ID_KEY];
};
const parseUtagCookie = () => {
  try {
    const cookies = parseCookies();
    const isLegacy = Boolean(cookies[UTAG_COOKIE_KEY_LEGACY]);
    if (!isLegacy) {
      const session_id = getNonLegacySessionId(cookies);
      const visitor_id = getNonLegacyVisitorId(cookies);
      if (!session_id) {
        logger.warn("Missing Tealium Session id");
      }
      if (!visitor_id) {
        logger.warn("Missing Tealium Visitor id");
      }
      return {
        tealium_session_id: session_id,
        tealium_visitor_id: visitor_id
      };
    } else {
      const utagCookie = cookies[UTAG_COOKIE_KEY_LEGACY] || "";
      const utagCookieObject = {};
      const utagCookieArray = utagCookie.split("$");
      for (let i = 0; i < utagCookieArray.length; i++) {
        const utagCookieKeyVal = utagCookieArray[i].split(":");
        utagCookieObject[utagCookieKeyVal[0]] = utagCookieKeyVal[1].split(";")[0];
      }
      if (!utagCookieObject[UTAG_COOKIE_SESSION_ID_KEY_LEGACY]) {
        logger.warn("Missing Tealium Session id");
      }
      if (!utagCookieObject[UTAG_COOKIE_VISITOR_ID_KEY_LEGACY]) {
        logger.warn("Missing Tealium Visitor id");
      }
      return {
        tealium_session_id: utagCookieObject[UTAG_COOKIE_SESSION_ID_KEY_LEGACY],
        tealium_visitor_id: utagCookieObject[UTAG_COOKIE_VISITOR_ID_KEY_LEGACY]
      };
    }
  } catch (error) {
    logger.error(
      "Event Horizon: There was an unexpected error while parsing the utag_main cookie",
      error
    );
    return {
      tealium_session_id: void 0,
      tealium_visitor_id: void 0
    };
  }
};
const getTealiumIds = () => new Promise((resolve) => {
  waitFor(
    utag,
    () => {
      const tealiumCookies = parseUtagCookie();
      resolve(tealiumCookies);
    },
    () => {
      resolve({
        tealium_session_id: void 0,
        tealium_visitor_id: void 0
      });
    }
  );
});
export {
  getTealiumIds as g
};
